export const dealerInitialStore = {
  dealerName: ''
};
